<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <repse-modal v-model="displayModal" :item="item" :vendor="vendor" @refresh="getData"/>
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-documentation-table
            :data="data"
            @edit="edit"
            @loadMore="loadMore"
            @search="search"
            @details="showDetails"
            :title="vendor.name"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
    
  <script>
import loading from '@/mixins/Loading'
import RepseDocumentationTable from './components/RepseDocumentationTable.vue'
import RepseModal from './components/RepseModal.vue'
import repse from '../requests/repse.js'

export default {
  components: {
    RepseDocumentationTable,
    RepseModal,
  },
  data() {
    return {
      data: [],
      displayModal: false,
      item: {},
      lastPage: 1,
      loadingPage: 'repse-documentation-loading',
      params: {
        search: '',
        page: 1,
      },
      vendor: {
        id: '',
        name: '',
      },
    }
  },
  methods: {
    edit: function (item) {
      this.displayModal = true
      this.item = Object.assign({},item)
    },
    getData: function () {
      this.openLoading(this.loadingPage)
      repse
        .getDocumentation(this.params,this.vendor.id)
        .then((response) => {
          this.data = response.data.documentation
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    getVendor: function (id) {
      this.openLoading(this.loadingPage)
      repse
        .getVendor(id)
        .then((response) => {
          this.vendor = Object.assign({}, response.data.vendor)
          this.closeLoading(this.loadingPage)
          this.getData()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    loadMore: function () {
      return
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    showDetails: function (id) {
      this.$router.push({ name: 'repse-requests', params: { id } })
    },
  },
  mixins: [loading],
  mounted() {
    let id = this.$route.params.id
    this.getVendor(id)
    
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(this.loadingPage)
      } else {
        this.closeLoading(this.loadingPage)
      }
    },
  },
}
</script>
    
    <style>
</style>